import { useState } from "react";
import { withRouter } from "react-router-dom";
import '../assets/css/partnerProgram.scss';
import '../assets/css/partnerPortal/salesEnablement.scss';



function Notes(props) {

    const [title] = useState(props.title);
    const [body] = useState(props.body);


    return (

        <>
        <div className="d-flex align-items-start align-self-stretch m-auto">
                <div className="sectionHeaderText">{title}</div>
        </div>
        <div className="d-flex align-items-start align-self-stretch salesTopicsText">
            {body}
        </div>
        </>

    )


}

export default withRouter(Notes);



